import DatabaseModel from './DatabaseModel.js';

var Dashboard = Object.create(DatabaseModel);

Dashboard.model = 'dashboard';

export default Dashboard;